<!--
  -  Copyright (C) Healabs 2022 - All Rights Reserved
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -
  -->

<template>
  <v-dialog :value="true" max-width="550" transition="dialog-bottom-transition" persistent>
    <v-card>
      <v-icon color="white" small class="close-submit-dialog" @click="close">$close</v-icon>
      <v-list class="pa-0">
        <v-img class="p-abs img-header" src="@/assets/img/login-default-bg.png" min-width="250" width="100%" max-height="70px" />
        <div class="title-header">
          <v-list-item-title class="text-h5 font-weight-light white--text px-5 p-rel white--text pt-2">Spécialité</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-alt mb-1 px-5 white--text p-rel">
            {{ specialty ? 'Modifier la spécialité' : 'Créer une nouvelle spécialité' }}
          </v-list-item-subtitle>
        </div>
        <div class="splitter" />
        <v-form ref="specialties" class="mt-2" @submit.prevent="submit">
          <v-row class="ma-0">
            <v-col cols="12">
              <v-text-field v-model="model.label" hide-details="auto" outlined dense rounded label="Nom de la spécialité" :rules="[$rules.required, $rules.maxLength(200)]" />
            </v-col>
          </v-row>
          <v-card-actions class="px-3">
            <v-spacer />
            <v-btn x-small rounded text @click="close">
              Annuler
            </v-btn>
            <v-btn x-small rounded color="success" type="submit" :loading="submitting" :disabled="submitting">
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
  import {create, update} from '@/modules/specialities/api'
  export default {
    name: 'SpecialityForm',
    props: {
      specialty: Object,
      value: Object
    },
    data() {
      return{
        submitting: false,
        successDialog: false,
        model: {
          id: this.specialty ? this.specialty.id : '',
          label: this.specialty ? this.specialty.label : ''
        }
      }
    },
    methods: {
      async submit() {
        if (!this.$refs.specialties.validate()) {
          return false
        }
        try {
          this.submitting = true
          let response = this.specialty ? await update(this.specialty.id, this.model) : await create(this.model)
          this.specialty ? this.$emit('update-specialities',  response.data) : this.$emit('add-specialities',  response.data)
          this.$emit('close')
          this.$root.$emit('snackbar:open', {
            snackbar: ()=> import('@/modules/core/components/Snackbar'),
            type: 'success',
            title: this.specialty ? 'Spécialité modifiée avec succès.' : 'Spécialité crée avec succès.'
          })
        } catch (error) {
          this.$root.$emit('snackbar:open', {
            snackbar: ()=> import('@/modules/core/components/Snackbar'),
            type: 'error',
            title: 'Une erreur est survenue'
          })
        } finally {
          this.submitting = false
        }
      },
      close() {
        this.$emit('close')
      }
    }
  }
</script>
